// extracted by mini-css-extract-plugin
export default {"input":"Input_input__C7FoV","label":"Input_label__cLUfo","errMsg":"Input_errMsg__Ly737"};